// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TIsSuitableOffersForCpdRequest,
  TIsSuitableOffersForCpdModel,
  IMappers,
  TIsSuitableOffersForCpdResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IIsSuitableOffersForCpdResponse } from '../../entities/v1_is_suitable_offers_for_cpd/IsSuitableOffersForCpdResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createIsSuitableOffersForCpdModel(
  parameters: TIsSuitableOffersForCpdRequest,
): TIsSuitableOffersForCpdModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'cpd',
    pathApi: '/v1/is-suitable-offers-for-cpd/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IIsSuitableOffersForCpdOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TIsSuitableOffersForCpdRequest;
}

export async function fetchIsSuitableOffersForCpd<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IIsSuitableOffersForCpdOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TIsSuitableOffersForCpdResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createIsSuitableOffersForCpdModel(parameters),
    config,
  )) as FetchResponse<TIsSuitableOffersForCpdResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IIsSuitableOffersForCpdResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TIsSuitableOffersForCpdResponse>;
}
